import React, { useEffect, useRef, useState } from "react";
import { ArrowLeft, AuBankIcon, AuBankSmallIcon, BusinessInformationIcon, BusinessInformationRedIcon, BusinessSecurityIcon, BusinessSecurityRedIcon, CreateAccountIcon, PasswordSettingIcon, PasswordSettingRedIcon, PersonalInformationIcon, PersonalInformationRedIcon, ProjExelLogo } from "../../assets/images";
import { DropDownType, UserDetailsType } from "./SignUpCard";
import { GetSignUpOtpPayloadType } from "../../commonTypes/authTypes";
type AppProps = {
  inputDetails: UserDetailsType;
  setInputDetails: React.Dispatch<React.SetStateAction<UserDetailsType>>;
  onVerify: (data: any) => void;
  handleBackToCreateAccount: () => void;
  countryDialCode: any;
  dispatchGetOtpSignUpAction: (data: GetSignUpOtpPayloadType) => void;
  resendTimer: number | null;
  setResendTimer: React.Dispatch<React.SetStateAction<number | null>>;
  timerRemaining: number;
  setTimeRemaining: React.Dispatch<React.SetStateAction<number>>;
  activeStep: number;

};
const VerifySignUpOtp = ({
  inputDetails,
  setInputDetails,
  onVerify,
  handleBackToCreateAccount,
  countryDialCode,
  dispatchGetOtpSignUpAction,
  resendTimer,
  setResendTimer,
  timerRemaining,
  setTimeRemaining,
  activeStep

}: AppProps) => {
     const {pathname} = window.location;
  const [otpDigits, setOtpDigits] = useState<any>(["", "", "", "", "", ""]);
  const inputRefs = useRef<any>([]);
  useEffect(() => {
    inputRefs.current = Array(6)
      .fill(null)
      .map(() => React.createRef<HTMLInputElement>());

    if (inputRefs?.current[0]?.current) {
      inputRefs?.current[0]?.current.focus();
    }
  }, []);


  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
    const pasteData = event?.clipboardData?.getData("text")?.trim()?.replace(/[^0-9]/g, '');

    if (pasteData?.length === 6) {
      const newOtpDigits = pasteData?.split("").slice(0, 6);
      setOtpDigits(newOtpDigits);
      setInputDetails({ ...inputDetails, otp: newOtpDigits.join('') });

      newOtpDigits?.forEach((digit, i) => {
        if (inputRefs.current[i]) {
          inputRefs.current[i].current.value = digit;
        }
      });

      if (inputRefs.current[5]) {
        inputRefs.current[5].current?.focus();
      }
    }
  };
  const handleOtpChange = (index: any, value: any) => {
    const newOtpDigits = [...otpDigits];

    newOtpDigits[index] = value;
    const numericValue = value.replace(/[^0-9]/g, '');
    newOtpDigits[index] = numericValue.slice(0, 1);
    setOtpDigits(newOtpDigits);
    if (
      value &&
      index < 5 &&
      inputRefs?.current &&
      inputRefs?.current[index + 1] &&
      inputRefs?.current[index + 1].current
    ) {
      inputRefs.current[index + 1]?.current?.focus();
    }

    setInputDetails({ ...inputDetails, otp: newOtpDigits.join("") });

  };

  const handleKeyDown = (index: any, event: any) => {
    if (event.key === "Backspace" && !otpDigits[index] && index > 0) {
      inputRefs.current[index - 1].current.focus();
    }
  };

  const handleResendOtp = () => {
    let finalData = {
      countryCode: countryDialCode?.value,
      mobileNumber: inputDetails?.mobileNumber
    }
    dispatchGetOtpSignUpAction(finalData)
    setResendTimer(60);
    setTimeRemaining(60);

    setOtpDigits(["", "", "", "", "", ""])

  }
  const handleVerifyandCreateAccount = () => {

    if (inputDetails?.otp?.length === 6) {
      const finalData = {
        countryCode: countryDialCode?.value,
        mobileNumber: inputDetails?.mobileNumber,
        otp: inputDetails?.otp
      }
      onVerify(finalData)
      setOtpDigits(["", "", "", "", "", ""])

    }
  };


  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };



  const steps = [
    {
      icon: CreateAccountIcon,
      redIcon: CreateAccountIcon,

    },
    {
      icon: AuBankSmallIcon,
      redIcon: AuBankSmallIcon,

    },
    {
      icon: BusinessSecurityIcon,
      redIcon: BusinessSecurityRedIcon,

    },

  ];
  const withoutAuSteps = [
         {
          icon: CreateAccountIcon,
          redIcon: CreateAccountIcon,
        },
     
        {
           icon: BusinessInformationIcon,
          redIcon: BusinessInformationRedIcon,
        },
        {
          icon: PasswordSettingIcon,
          redIcon: PasswordSettingRedIcon,
          },
      
      ];
            const stepsToDisplay = pathname==="/signup" ? withoutAuSteps :steps ;

  return (
    <>
      <div className="main-signup">
        <div className="mt-5 main-signup-Container" >

          <div className="logo-section mb-3">
            <div className="d-flex justify-content-center align-items-center">
              <img src={ProjExelLogo} className="company-logo" alt="finac-logo"/>
              {pathname==="/signup"?"":
              <img src={AuBankIcon} className="company-logo" alt="au-logo" style={{ height: "50px", marginLeft: "27px" }} />
              }
            </div>
            <div style={{ display: 'flex', marginBottom: '30px', width: '258px', alignItems: 'center', justifyContent: "center" }}>
              {stepsToDisplay?.map((step, index) => (
                < >

                  <div key={index} className="step-indicator">
                    <span
                      className={`step${activeStep === index ? "active" : ""
                        }`}
                    >
                      <img
                        src={
                          activeStep === index || activeStep > index
                            ? step?.redIcon
                            : step?.icon
                        }
                        alt={' Icon'}
                      />
                    </span>
                    <span className="line"></span>
                  </div>

                </>

              ))}
            </div>

          </div>


          <img
            src={ArrowLeft}
            onClick={handleBackToCreateAccount}
            style={{ cursor: "pointer" }}
            className="back-button-img"
          />
          <h5 className="mt-2 right-panel-heading">Verify Mobile Number</h5>
          <span className="right-panel-subHeading">
            We have successfully sent 6 digit OTP to your number. Please enter
            below to verify your identity.
          </span>

          <div
            className="mt-4"
            style={{ display: "flex", justifyContent: "start" }}
          >
            {otpDigits.map((digit: any, index: any) => (
              <input
                key={index}
                type="number"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                ref={inputRefs.current[index]}
                style={{
                  width: "40px",
                  height: "40px",
                  margin: "5px",
                  textAlign: "center",

                }}
                onPaste={handlePaste}
              />
            ))}
          </div>
          <div className="mb-3 mt-3 pr-0 pl-0" style={{ maxWidth: "298px" }}>
            <button
              type="submit"
              className="btn btn-primary w-100"
              onClick={handleVerifyandCreateAccount}
              disabled={inputDetails?.otp.length < 6}

            >
              Verify & Create Account
            </button>
          </div>
          <div style={{ textAlign: "center" }}>
            <p
              className="mt-2 mb-1 resend-link text-center"

            >
              Didn’t receive OTP?
            </p>
            {resendTimer === null ? (
              <p className="resend-otp"
                onClick={handleResendOtp}
              >
                Resend OTP
              </p>
            ) : (
              <p
                className="again-resend-otp"
              >
                Resend OTP in {formatTime(timerRemaining)}
              </p>
            )}
          </div>

          <div className="flex-row">
            <p className="resend-link text-center" >
              Already have an account?{" "}
              <a
                style={{ color: "#dd4433", cursor: "pointer" }}
                href="/login"
                target="_blank"
              >
                Sign In
              </a>
            </p>
          </div>
          <p className="mobileCopyright">
            &copy; Copyright 2025 | AKSSAI ProjExel | All right reserved
          </p>
        </div>

      </div>
    </>
  );
};

export default VerifySignUpOtp;
